module.exports = __webpack_public_path__ + "img/progetti_master_prjweb.96ab344e.png";